import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';

const ProviderWasteTippingJobs = ({
    provider,
    dataUrl,
    backUrl
}) => {

    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchJobs();
    }, []);

    const fetchJobs = async () => {
        try {
            const res = await axios.get(dataUrl);

            setJobs(res.data.data || []);
        } catch (err) {
            console.error(
                'Failed to load waste tipping jobs:',
                err
            );
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="text-center py-5">
                <i className="fas fa-spinner fa-spin"></i>
                {' '}
                Loading provider jobs...
            </div>
        );
    }

    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h5 className="mb-0">
                        {provider.company_name || provider.name}
                    </h5>

                    <small className="text-muted">
                        Completed jobs awaiting waste tipping
                    </small>
                </div>

                <a
                    href={backUrl}
                    className="btn btn-secondary"
                >
                    Back
                </a>
            </div>

            <div className="table-responsive">
                <table className="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th>Job #</th>
                            <th>Completion Date</th>
                            <th>Address</th>
                            <th>Tipping Site</th>
                        </tr>
                    </thead>

                    <tbody>
                        {jobs.map((job) => (
                            <tr key={job.id}>
                                <td>
                                    <strong>
                                        #{job.id}
                                    </strong>
                                </td>

                                <td>
                                    {job.completion_date || '—'}
                                </td>

                                <td>
                                    <div>
                                        {job.address}
                                    </div>

                                    {job.postcode ? (
                                        <small className="text-muted">
                                            {job.postcode}
                                        </small>
                                    ) : null}
                                </td>

                                <td>
                                    {job.tipping_site || '—'}
                                </td>
                            </tr>
                        ))}

                        {!jobs.length && (
                            <tr>
                                <td
                                    colSpan="7"
                                    className="text-center text-muted py-4"
                                >
                                    No outstanding jobs.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default ProviderWasteTippingJobs;

const el = document.getElementById(
    'providerWasteTippingJobs'
);

if (el) {
    ReactDOM.render(
        <ProviderWasteTippingJobs
            provider={JSON.parse(el.dataset.provider)}
            dataUrl={el.dataset.dataUrl}
            backUrl={el.dataset.backUrl}
        />,
        el
    );
}